import { Col, Row } from "react-bootstrap";
import "styles/page.css";
import aboutusImg from "assets/images/about-us.png";
import { PrimaryButton } from "components/buttons";
import rightIcon from "assets/images/about_right.svg";
import aboutBgIcon from "assets/images/about_bg.svg";
import aboutBodIcon from "assets/images/about_bod.svg";
import aboutNewsIcon from "assets/images/about_news.svg";
import aboutReportIcon from "assets/images/about_report.svg";

import { Link } from "react-router-dom";

function About() {
  return (
    <>
      <style type="text/css">
        {`

          .about-us {
            margin-top: 40px;
          
            img {
              border-radius: 20px;
            }

            p {
              color: var(--gray-500-body-text, #72788E);
              font-family: "Ping AR + LT";
              font-size: 16px;
              font-style: normal;
              font-weight: 400;
              line-height: 150%; /* 24px */
              letter-spacing: -0.368px;
            
              span {
                color: var(--alrajhi-Brand-600, #221AFB);
              }
            }
          }

          .about-card-row {
            --bs-gutter-x: 16px;
          }
          .about-card {
            border-radius: 15px;
            border: 1px solid var(--Gray-300, #D0D5DD);
            background: var(--white, #FFF);
            padding: 20px;
            margin: 8px;
            display: flex;
            align-items: center;

            p {
              padding: 0px 16px ;
              margin: 0px;
              color: var(--alrajhi-Brand-1000, #000045);
              text-align: left;
              font-family: "Ping AR + LT";
              font-size: 16px;
              font-style: normal;
              font-weight: 700;
              line-height: 24px; /* 150% */
            }

            img {
              width: 20px;
              height: 20px;
            }
          }

       
        `}
      </style>

      <div className="container about-us">
        <img src={aboutusImg} alt="banner" width={"100%"} />
        <div style={{ height: "40px" }}></div>
        <h4 className="page-heading ">
          alrajhi bank Malaysia: A Leading Islamic Bank in Southeast Asia
        </h4>
        <p className="page-subtitle">
          alrajhi bank Malaysia is the first Saudi Arabian Islamic financial
          institution to operate in Southeast Asia. Locally incorporated in 2005
          and licensed by the Malaysian Minister of Finance in 2006, we are a
          wholly owned subsidiary of alrajhi bank Kingdom of Saudi Arabia, one
          of the largest banks in the world by market capitalisation and the
          largest in the Middle East and Saudi Arabia.
          <br />
          <br />
          We provide comprehensive Shariah-compliant financial services,
          bridging modern financial demands with ethical values. Our offerings
          include personal finance, financing for corporate customers, home
          financing, cash management, and among the best savings account rates,
          accessible through our 13 branches across Peninsular and East
          Malaysia, including the Klang Valley.
          <br />
          <br />
          Experience seamless online and mobile banking with our
          alrajhi@24/seven website and app or our innovative, cloud-based Rize
          by alrajhi bank Malaysia app —launched in 2023 —offering digital
          banking features directly on your smartphone.
        </p>

        <div style={{ height: "40px" }}></div>
        <div className="d-flex justify-content-center">
          <Link to="https://www.alrajhibank.com.sa/About-alrajhi-bank" target="blank">
            <PrimaryButton text={"Learn more about alrajhi bank"} />
          </Link>
        </div>
        <div style={{ height: "40px" }}></div>
        <Row className="about-card-row">
          {/* <Col md={6} xs={12}>
            <Link
              style={{ textDecoration: "none" }}
              to="/about/corporate-info/our-background"
            >
              <div className="about-card">
                <img src={aboutBgIcon} alt="right" />
                <p className="flex-fill text-left">Our Background</p>
                <img src={rightIcon} alt="right" />
              </div>
            </Link>
          </Col> */}

          <Col xl={4} md={6} xs={12}>
            <Link style={{ textDecoration: "none" }} to="/financial-report">
              <div className="about-card">
                <img src={aboutReportIcon} alt="right" />
                <p className="flex-fill text-left">Financial Reports</p>
                <img src={rightIcon} alt="right" />
              </div>
            </Link>
          </Col>

          <Col xl={4} md={6} xs={12}>
            <Link
              style={{ textDecoration: "none" }}
              to="/about/corporate-profile/board-of-directors"
            >
              <div className="about-card">
                <img src={aboutBodIcon} alt="right" />
                <p className="flex-fill text-left">Board of Directors</p>
                <img src={rightIcon} alt="right" />
              </div>
            </Link>
          </Col>

          <Col xl={4} md={6} xs={12}>
            <Link style={{ textDecoration: "none" }} to="/news/">
              <div className="about-card">
                <img src={aboutNewsIcon} alt="right" />
                <p className="flex-fill text-left">News & Announcements</p>
                <img src={rightIcon} alt="right" />
              </div>
            </Link>
          </Col>
        </Row>
        <div style={{ height: "80px" }}></div>
      </div>
    </>
  );
}

export default About;
